import { render, staticRenderFns } from "./WriteContentBtn.vue?vue&type=template&id=fe9a44de&"
import script from "./WriteContentBtn.vue?vue&type=script&lang=ts&"
export * from "./WriteContentBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports